import React from 'react'
import SideBar from './SideBar'
import { Outlet } from 'react-router-dom'

const Layout = () => {
  return (
    <div className="side_panal">
      <div className="d-flex w-100">
        <SideBar />
        <div className="rightView">
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default Layout